<div class="agreement-signers"
     *ngIf="rows.length">
  <div class="agreement-signers__row"
       *ngFor="let row of rows; trackBy: trackByCustomerId">
    <span class="agreement-signers__avatar">{{ row.initials }}</span>

    <span class="agreement-signers__identity">
      <span class="agreement-signers__name">{{ row.fullName }}</span>
      <span class="agreement-signers__role">Business owner</span>
    </span>

    <span class="agreement-signers__status"
          [ngClass]="'agreement-signers__status--' + row.statusModifier">{{ row.statusLabel }}</span>
  </div>
</div>
